/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsHeader = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData($section));
      this.isDesktop = this.getCurrentWindowSize()
      this.isMenuOpen = false
      this.activeMenuLink = -1
      this.activeTabTrigger = -1
      this.isSearchOpen = false
      this.activeSublink = -1

      this.$el = $('#header')
      this.$headers = [$('#mobile-header'), $('#header')]

      this.$menuTrigger = $('[data-show-menu-trigger]')

      this.$menu = $('[data-main-menu]')
      this.$menuLinks = this.$menu.find('[data-main-menu-link]')
      this.$menuSubLinks = this.$menu.find('[data-main-menu-sublink]')
      this.$menuSubLinkImages = this.$menu.find('[data-main-menu-image]')
      this.$menuTabTriggers = this.$menuLinks.find('[data-main-menu-tab-trigger]')
      this.$menuTabs = this.$menu.find('[data-main-menu-tab]')
      this.$menuTabCloseTriggers = this.$menuTabs.find('[data-main-menu-tab-close]')

      this.$searchOverlay = $('[data-search-overlay]')
      this.$searchTrigger = $('[data-show-search-trigger]')

      this.menuTimeline = {}
      this.linkTimelines = []
      this.tabTimelines = [[], []]
      this.subLinkTimelines = [[], []]
      this.searchTimeline = {}


      this.handleInit()
      this.initTimelines()
      this.handleEvents()
    },
    handleInit: function () {
      let announcementHeight = $('.announcement-sticky-wrapper').height();

      // Overlaid header
      if (this.enable_overlay === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }else{
        $('[data-check-for-order]').css('padding-top',this.getHeaderHeight())
      }

      // Sticky header
      if (this.enable_sticky === true && isScreenSizeLarge()) {
        this.enableSticky(announcementHeight);

        $(window).on('resize', () => {
          this.enableSticky(announcementHeight);
        });
      }
    },
    handleEvents: function () {
      this.$menuTrigger.on('click', this.handleMenuClick.bind(this))

      this.$menuLinks.on('click', function (e) {
        this.toggleMenuTab(e)
        this.animateLink(e)
      }.bind(this))
      // this.$menuTabTriggers.on('change', )
      this.$menuTabCloseTriggers.on('click', this.toggleMenuTab.bind(this))

      this.$menuSubLinks.hover(this.toggleSublinkImage.bind(this))
      this.$searchTrigger.on('click', this.handleSearchClick.bind(this))

      $(window).on('resize', this.reset.bind(this))
    },
    reset: function () {
      this.isDesktop = this.getCurrentWindowSize()
      let resetIndex = this.isDesktop == 1 ? 0 : 1

      if (!this.tabTimelines[this.isDesktop].length) {
        this.isDesktop == 1 ? this.initDesktopTimelines() : this.initMobileTimelines()
      }
      this.tabTimelines[resetIndex].map(function (tl) {
        tl.revert()
      })
    },
    getCurrentWindowSize: function () {
      if ($(window).width() > 798)
        return 1
      return 0
    },
    handleSearchClick: function () {
      if (this.isSearchOpen) {
        return this.hideSearch()
      }
      this.closeMenu()
      return this.showSearch()
    },
    handleMenuClick: function () {
      if (this.isMenuOpen) {
        return this.closeMenu()
      }
      this.hideSearch()
      return this.openMenu()
    },
    initTimelines: function () {
      this.menuTimeline = gsap.timeline({ paused: true });
      this.menuTimeline.to(this.$menu, { y: 0, duration: 1, ease: Expo.easeOut })
      this.menuTimeline.to(this.$menu.find('.section'), { opacity: 1, duration: 1, ease: Power1.easeOut }, "-=0.2")

      this.$menuLinks.each(function (index, link) {
        let tl = gsap.timeline({ paused: true });
        tl.to($(link), { opacity: 1, duration: 0.5, ease: Expo.easeOut })
        tl.to($(link).find('.caption'), { x: 30, duration: 0.5, ease: Expo.easeOut }, "-=0.5")
        tl.to($(link).find('.icon'), { opacity: 1, duration: 0.5, ease: Power1.easeOut }, "-=0.5")
        this.linkTimelines.push(tl)
      }.bind(this))

      if (this.isDesktop)
        this.initDesktopTimelines()
      else
        this.initMobileTimelines()

      this.searchTimeline = gsap.timeline({ paused: true });
      this.searchTimeline.to(this.$searchOverlay, { y: 0, duration: .6, ease: Expo.easeOut })
      this.searchTimeline.to(this.$searchOverlay.find('.section'), { opacity: 1, duration: 0.6, ease: Power1.easeOut })

    },
    initDesktopTimelines: function () {
      this.$menuTabs.each(function (index, tab) {
        let tl = gsap.timeline({ paused: true });
        tl.fromTo($(tab), { opacity: 0 }, { opacity: 1, duration: 0.5, ease: Expo.easeOut })
        tl.to($(tab), { x: 20, duration: 0.5, ease: Expo.easeOut }, "-=0.5")
        tl.set($(tab), { zIndex: 1 })
        this.tabTimelines[1].push(tl)
      }.bind(this))

      this.$menuSubLinkImages.each(function (index, image) {
        let tl = gsap.timeline({ paused: true });
        tl.to($(image), { opacity: 1, duration: 0.5, ease: Expo.easeOut })
        this.subLinkTimelines[1].push(tl)
      }.bind(this))

    },
    initMobileTimelines: function () {

      this.$menuTabs.each(function (index, tab) {
        let tl = gsap.timeline({ paused: true });
        tl.set(this.$headers[0], { zIndex: 9 })
        tl.to($(tab), { opacity: 1, duration: 0.5, ease: Expo.easeOut })
        tl.to($(tab), { x: 0, duration: 0.5, ease: Expo.easeOut }, "-=0.5")
        this.tabTimelines[0].push(tl)
      }.bind(this))
    },
    openMenu: function () {
      this.$menuTrigger.addClass('is-active')
      this.isMenuOpen = true
      this.$headers[this.isDesktop].addClass('is-fixed-menu')
      let headerHeight = this.getHeaderHeight()
      this.$menu.css('padding-top', headerHeight)
      this.menuTimeline.play()

    },
    closeMenu: function () {

      setTimeout(function () {
        if (!this.isMenuOpen) {
          this.$headers[this.isDesktop].removeClass('is-fixed-menu')
        }

      }.bind(this), 2000)
      this.$menuTrigger.removeClass('is-active')
      this.isMenuOpen = false
      this.menuTimeline.reverse()
    },
    toggleSublinkImage: function (e) {
      let currentIndex = $(e.target).data('index')
      //if index is wrong close do nothing
      if (currentIndex == undefined || currentIndex >= this.subLinkTimelines[1].length) return;
      //if there is an active link,reverse that
      if (this.activeSublink > -1) {
        this.subLinkTimelines[1][this.activeSublink].reverse()
      }
      //if the selected link is same as the active one,do not animate it again and active to -1(none)
      if (currentIndex == this.activeSublink) {
        this.activeSublink = -1
        return;
      }
      //finally animate the selected link
      this.activeSublink = currentIndex
      this.subLinkTimelines[1][this.activeSublink].play()
    },
    animateLink: function (e) {
      let currentIndex = $(e.target).data('index')
      //if index is wrong close do nothing
      if (currentIndex == undefined || currentIndex >= this.linkTimelines.length) return;
      //if there is an active link,reverse that
      if (this.activeMenuLink > -1) {
        this.linkTimelines[this.activeMenuLink].reverse()
      }
      //if the selected link is same as the active one,do not animate it again and active to -1(none)
      if (currentIndex == this.activeMenuLink) {
        this.activeMenuLink = -1
        return;
      }
      //finally animate the selected link
      this.activeMenuLink = currentIndex
      this.linkTimelines[this.activeMenuLink].play()
    },
    toggleMenuTab: function (e) {
      let currentIndex = $(e.target).data('index')
      if (currentIndex == undefined || currentIndex >= this.linkTimelines[this.isDesktop].length) return;
      //link with no tab was selected
      if (currentIndex >= this.tabTimelines[this.isDesktop].length) {
        this.activeTabTrigger > -1 && this.tabTimelines[this.isDesktop][this.activeTabTrigger].reverse()
        this.activeTabTrigger = -1
        return;
      }
      if (this.activeTabTrigger > -1) {
        this.tabTimelines[this.isDesktop][this.activeTabTrigger].reverse()
      }
      if (this.activeTabTrigger == currentIndex) {
        this.linkTimelines[this.activeMenuLink].reverse()
        this.activeTabTrigger = -1
        return;
      };
      this.activeTabTrigger = currentIndex
      this.tabTimelines[this.isDesktop][this.activeTabTrigger].play()
    },
    disableSticky: function () {
      let $stickyEl = $('#header');

      $stickyEl.unstick();
      $stickyEl.removeClass('sticky--enabled');

      setTimeout(function () {
        $stickyEl.css('height', 'auto');
      }, 250)
    },
    enableSticky: function (offset) {
      let $stickyEl = this.$el;

      $stickyEl.addClass('sticky--enabled');

      $stickyEl.sticky({
        wrapperClassName: 'header-sticky-wrapper',
        zIndex: 40,
        topSpacing: offset || 0
      })
        .on('sticky-start', () => {
          let headerHeight;
          let announcementHeight;

          // Hide the mini cart for centered header layout
          if (Shopify.theme_settings.header_layout == 'centered') {
            $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
          }

          // Get header height is sticky enabled
          if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
            headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
          }

          // Get announcement height is sticky enabled
          if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
            announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
          } else {
            announcementHeight = 0;
          }

          let totalHeight = headerHeight + announcementHeight;
          $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

          if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {

            $stickyEl.parent().addClass('has-overlaid-header');
            this.disableOverlayStyle();

          } else if (this.enable_overlay === true) {

            this.disableOverlayStyle();

          }
        })
        .on('sticky-end', () => {
          $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

          // Safety timeout for logo width transition which can throw calculated height off
          setTimeout(() => {
            $stickyEl.sticky('update');
          }, 250);

          this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');

          if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
            this.updateOverlayStyle(this.sectionUnderlayIsImage());
          }
        })
    },
    disableOverlayStyle: function () {
      $('[data-enable_overlay]').attr('data-enable_overlay', false);
    },
    enableOverlayStyle: function () {
      $('[data-enable_overlay]').attr('data-enable_overlay', true);
    },
    updateOverlayStyle: function (overlayBoolean) {
      $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
    },
    sectionUnderlayIsImage: function () {

      let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

      // Check whether the first element has class to indicate it should be under header when overlay is enabled
      if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
        return true;
      } else {
        return false;
      }

    },
    showSearch: function () {
      this.$searchTrigger.addClass('is-active')
      this.isSearchOpen = true
      this.$headers[this.isDesktop].addClass('is-fixed-search')
      let headerHeight = this.getHeaderHeight()
      this.$searchOverlay.css('padding-top', headerHeight)
      this.searchTimeline.play()
    },
    hideSearch: function () {
      setTimeout(function () {
        if (!this.isSearchOpen) {
          this.$headers[this.isDesktop].removeClass('is-fixed-search')
        }
        document.querySelector('.search-overlay').style.transform = "translate(0, -100%)";
      }.bind(this), 2000)
      this.$searchTrigger.removeClass('is-active')
      this.isSearchOpen = false
      this.searchTimeline.reverse()
    },
    addOffScreenDropdownCheck: function () {
      $('.navbar-item.has-dropdown--vertical').hover(function () {

        const dropdown = $(this),
          menu = dropdown.find('.navbar-dropdown');

        menu.removeClass('navbar-dropdown--fix-offscreen');

        if (menu.is(':off-screen')) {
          menu.addClass('navbar-dropdown--fix-offscreen');
        }

      });
    },
    getHeaderHeight: function () {
      const headerHeight = this.$headers[this.isDesktop].outerHeight() || 0;
      return headerHeight;
    },
    unload: function ($section) {
      $('.has-overlaid-header').removeClass('has-overlaid-header');
      $('[data-show-search-trigger]').off();
      $('.navbar-item').off();
      $('#header').off();
      $('.dropdown-click--true .header__link').off();
      this.disableSticky();
      this.disableOverlayStyle();
    }
  }

  /******/
})()
  ;